import FJLocalStore from '../../../store/FJLocalStore';
import styles from './FJCategoryItemSeeAll.module.less';
import PropTypes from 'prop-types';
import FJMoreIcon from '../../../assets/svg/community/more-small.svg?react';
const FJCategoryItemSeeAll = props => {
    const { seeAll } = props;

    const onClick = () => {
        seeAll && seeAll();
    };

    return (
        <div className={styles.see_all_default} onClick={onClick}>
            {FJLocalStore._('see-all')}
            <FJMoreIcon />
        </div>
    );
};
FJCategoryItemSeeAll.propTypes = {
    seeAll: PropTypes.func,
};
export default FJCategoryItemSeeAll;
